import { usdToCurrency } from '../../config/pricing'
import { getCurrency } from '../../services/PricingUtils'
import { formatPrice } from '../../utils/utils'

export const getReferralPrice = () => {
  return formatPrice(usdToCurrency(20, getCurrency()), getCurrency())
}
